var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"codics-factory-amdin-left",style:({ width: _vm.isCollapse ? '65px' : '270px' })},[_c('MenuTree',{ref:"leftMenu",attrs:{"is-collapse":_vm.isCollapse,"menuList":_vm.menuList}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }